var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4579 9C15.4579 10.8936 13.9094 12.4286 11.9995 12.4286C10.0895 12.4286 8.54116 10.8936 8.54116 9C8.54116 7.1064 10.0895 5.57143 11.9995 5.57143C13.9094 5.57143 15.4579 7.1064 15.4579 9Z",
    stroke: "#CFCFCF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9C2.46895 4.36329 6.8383 1 12 1C17.1617 1 21.531 4.36333 23 9C21.531 13.6367 17.1617 17 12 17C6.83828 17 2.46892 13.6367 1 9Z",
    stroke: "#CFCFCF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/open-eye.cb8593f0a5a16472c63b4a3a6cb8c01d.svg";
export { ForwardRef as ReactComponent };